// extracted by mini-css-extract-plugin
export default {"fieldContainer":"ProductCategory_fieldContainer__HxUEd"};